import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Category } from '../../interface/delegationofauthority/category';
import { Type } from '../../interface/delegationofauthority/type';
import { DoaDollarDirectReports, Doatypelist } from '../../interface/delegationofauthority/doatypelist';
import { EffectiveDateAndAmount, Employeedetails, employeedetailsdirectreports } from '../../interface/delegationofauthority/employeedetails';
import { IResult } from '../../interface/delegationofauthority/doa';
import { Departmentdivisionlist } from '../../interface/delegationofauthority/departmentdivisionlist';
import { IType, IDepartments, IDoaCategory, IDivisions } from '../../interface/delegationofauthority/searchdoa';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DelegationofauthorityService {
  private baseUrl = environment.apiUrl;
  private costcenterdata: any = null;
  constructor(private http: HttpClient) { }

  setParentData(data: any): void {
     this.costcenterdata = data; 
    } 
  getParentData(): any { 
    return this.costcenterdata; 
  } 
  clearData(): void { 
    this.costcenterdata = null;
   }

  getCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${this.baseUrl}/DelegationOfAuthority/GetCategory`);
  }

  getTypes(): Observable<Type[]> {
    return this.http.get<Type[]>(`${this.baseUrl}/DelegationOfAuthority/GetTypes`);
  }
  
  getEmployees(selectedCategory: string, selectedType: string, selectedOrder: string): Observable<Doatypelist[]> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetEmployees?sCat=${selectedCategory}&sTyp=${selectedType}&sOrd=${selectedOrder}`;
    return this.http.get<Doatypelist[]>(url);
  }

  getEmployeeDetailsByEmpNo(empNo: string): Observable<Employeedetails> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetEmployeeDetailsByEmpNo?nEmpNo=${empNo}`;
    return this.http.get<Employeedetails>(url);
  }

  getEffectiveDate(empNo: string): Observable<string> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetEffectiveDate?nEmpNo=${empNo}`;
    return this.http.get(url, { responseType: 'text' });
  }

  getConversionRate(): Observable<string> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetConversionRate`;
    return this.http.get(url, { responseType: 'text' });
  }

  getDoaDetails(empNo: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/DelegationOfAuthority/GetDoaDetails?nEmpNo=${empNo}`);
  }

  getRedelegations(empNo: string): Observable<any[]> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetRedelegations?nEmpNo=${empNo}`;
    return this.http.get<any[]>(url);
  }

  getEmployeesdirectreports(selectedCategory: string, selectedType: string, selectedCAI: string): Observable<Doatypelist[]> {
    const url = `${this.baseUrl}/DelegationOfAuthority/Get_Employees_DirectReportes?sCat=${selectedCategory}&sTyp=${selectedType}&sUserCAI=${selectedCAI}`;
    return this.http.get<Doatypelist[]>(url);
  }

  public getEmployeeDOA(
    searchBy: string,
    entervalue: string,
    sortResultBy: string,
    sortOrder: string
  ): Observable<IResult[]> {
    const params = new HttpParams()
      .set('searchBy', searchBy)
      .set('entervalue', entervalue)
      .set('sortResultBy', sortResultBy)
      .set('sortOrder', sortOrder);
    return this.http.get<IResult[]>(`${this.baseUrl}/DelegationOfAuthority/GetSearchEmployees`, { params });
  }
  //   public getEmployeeDOA(
  //     searchBy: string,
  //     criteria: string,
  //     entervalue: string,
  //     sortResultBy: string,
  //     sortOrder: string
  //   ): Observable<IResult[]> {
  //     const params = new HttpParams()
  //       .set('searchBy', searchBy)
  //       .set('criteria', criteria)
  //       .set('entervalue', entervalue)
  //       .set('sortResultBy', sortResultBy)
  //       .set('sortOrder', sortOrder);
  //   return this.http.get<IResult[]>(`${this.baseUrl}/DelegationOfAuthority/GetSearchEmployees`, { params });
  // }
  getEmployeesByCostCenter(costCenterOp: string, costCenterValue: string, orderBy: string): Observable<any[]> {
    const queryParam = `${costCenterOp} ${costCenterValue}`;
    return this.http.get<any[]>(`${this.baseUrl}/DelegationOfAuthority/GetCostCenterEmployee?sCost_Center=${queryParam}&orderBy=${orderBy}`);
  }

  getDepartmentDivisions(selectedDepartment: string, selectedDivision: string, selectedOrder: string): Observable<Departmentdivisionlist[]> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetEmployees?sCat=${selectedDepartment}&sTyp=${selectedDivision}&sOrd=${selectedOrder}`;
    return this.http.get<Departmentdivisionlist[]>(url);
  }

  getEmployeeMasterWorksheet(costCenterOp: string, costCenterValue: string, orderBy: string): Observable<Blob> {
    const queryParam = `${costCenterOp} ${costCenterValue}`;
    const url = `${this.baseUrl}/DelegationOfAuthority/GetCostCenterEmployeeWorksheet?sCost_Center=${queryParam}&orderBy=${orderBy}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  getDepartmentDivisionWorksheet(deptId: string,divisionid: string, orderBy: string): Observable<Blob> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetDepartmentDivisionWorksheet?deptId=${deptId}&divisionid=${divisionid}&orderBy=${orderBy}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  getDOATypes(): Observable<IType[]> {
    return this.http.get<IType[]>(`${this.baseUrl}/DelegationOfAuthority/GetDoaTypes`);
  }

  getDepartments(): Observable<IDepartments[]> {
    return this.http.get<IDepartments[]>(`${this.baseUrl}/DelegationOfAuthority/GetAllDepartments`);
  }
  getDepartmentsFromcloudService(): Observable<IDepartments[]> {
    return this.http.get<IDepartments[]>(`${this.baseUrl}/DelegationOfAuthority/GetAllDepts`);
  }
  getSepficDivisionsFromcloudService(deptId: string): Observable<employeedetailsdirectreports> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetSepficDivisions?deptId=${deptId}`;
    return this.http.get<employeedetailsdirectreports>(url);
  }
  getDoaCategory(): Observable<IDoaCategory[]> {
    return this.http.get<IDoaCategory[]>(`${this.baseUrl}/DelegationOfAuthority/GetDoaCategories`);
  }

  getDivisions(): Observable<IDivisions[]> {
    return this.http.get<IDivisions[]>(`${this.baseUrl}/DelegationOfAuthority/GetAllDivisions`);
  }

  getPredefinedReport(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/DelegationOfAuthority/PredefinedReport`);
  }

  perviewReportExcel(dataSource: any[]): Observable<any> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetExcelsheetPreviewReport`;
    return this.http.post(url, dataSource);
  }

  getDOATypeWorksheet(selectedCategory: string, selectedType: string, selectedOrder: string): Observable<Blob> {
    const url = `${this.baseUrl}/DelegationOfAuthority/DOATypeWorksheet?sCat=${selectedCategory}&sTyp=${selectedType}&sOrd=${selectedOrder}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  getdirectreportsworksheet(selectedCategory: string, selectedType: string, selectedCAI: string): Observable<Blob> {
    const url = `${this.baseUrl}/DelegationOfAuthority/DirectReporteWorksheet?sCat=${selectedCategory}&sTyp=${selectedType}&sUserCAI=${selectedCAI}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  fetchperviewVWData(formData: any, searchTableName: string, selectedReport: string): Observable<any> {
    let params = new HttpParams().set('tableName', searchTableName).set('SelectReport', selectedReport);
    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        params = params.set(key, formData[key]);
      }
    }
    const url = `${this.baseUrl}/DelegationOfAuthority/FetchPreviewVWData`;
    return this.http.get(url, { params }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching data', error);
        return throwError(() => new Error('Error fetching data'));
      })
    );
  }

  getVwPerviewReportWorkSheet(dataSource: any[]): Observable<Blob> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetDOAVwPerviewReportWorkSheet`;
    return this.http.post(url, dataSource, { responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error generating Excel file', error);
        return throwError(() => new Error('Error generating Excel file'));
      })
    );
  }

  getVwPerviewReportData(formData: any): Observable<any> {
    let params = new HttpParams();
    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        params = params.set(key, formData[key]);
      }
    }
    const url = `${this.baseUrl}/DelegationOfAuthority/GetDOAActiveOreInactiveVW`;
    return this.http.get(url, { params }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching data', error);
        return throwError(() => new Error('Error fetching data'));
      })
    );
  }

  getDepartmentDivisionDetails(deptId: string,  divisionid: string,  orderBy: string): Observable<Departmentdivisionlist[]> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetDepartmentDivisionDetails?deptId=${deptId}&divisionid=${divisionid}&orderBy=${orderBy}`;
    return this.http.get<Departmentdivisionlist[]>(url);
  }

  getEmployeeDetails(empNoCaiOrUserId: string): Observable<employeedetailsdirectreports> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetEmployeeDetails?empNoCaiOrUserId=${empNoCaiOrUserId}`;
    return this.http.get<employeedetailsdirectreports>(url);
  }
  
  getDoaEffectiveDateAndAmount(empNo: string, category: string, type: string): Observable<EffectiveDateAndAmount> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetDoaEffectiveDateAndAmount?nEmpNo=${empNo}&sCat=${category}&sTyp=${type}`;
    return this.http.get<EffectiveDateAndAmount>(url);
  }
}
